import React from 'react';
import PropTypes from 'prop-types';

import { formatCurrency } from 'utils/currency';
import { btnLocationEnum } from 'utils/segment';

import ProductDetailPageCTA from '../ProductDetailPageCTA/ProductDetailPageCTA';
import ShippingRestrictions from '../ShippingRestrictions/ShippingRestrictions';
import SubscribeAndSaveDetails from '../../Products/SubscribeAndSaveDetails/SubscribeAndSaveDetails';

import styles from './SubscribableDetails.module.scss';

const SubscribableDetails = ({
  id,
  productName,
  price,
  salePrice,
  percentOff,
  sku,
  soldOut,
  planPrice,
  shippingRestrictions,
  ctaElementRef,
  isParisHiltonKit,
  isSubscriptionAvailable,
  isUpdatingCart,
  addToPublicCart,
}) => (
  <div className={styles.subscribableDetails} ref={ctaElementRef}>
    <div className={styles.priceContainer}>
      <h2>{formatCurrency(salePrice)}</h2>
      {!isSubscriptionAvailable && (
        <div className={styles.introOffer}>
          <span>Intro Membership Offer</span>
        </div>
      )}
    </div>
    <div className={styles.discountContainer}>
      <p className={styles.msrp}>
        MSRP: <span>{formatCurrency(price)}</span>
        <i
          className="fas fa-info-circle"
          data-tip="The price shown represents the product's estimated original retail price."
        />
      </p>
      <p className={styles.percentOff}>({percentOff}% off)</p>
    </div>
    {isParisHiltonKit && (
      <div className={styles.memberExclusiveKit}>MEMBER-EXCLUSIVE KIT</div>
    )}
    {isSubscriptionAvailable && <SubscribeAndSaveDetails />}
    <div>
      <ShippingRestrictions restrictions={shippingRestrictions} />
    </div>
    <ProductDetailPageCTA
      id={id}
      sku={sku}
      soldOut={soldOut}
      salePrice={salePrice}
      productName={productName}
      isSubscriptionAvailable={isSubscriptionAvailable}
      isParisHiltonKit={isParisHiltonKit}
      isUpdatingCart={isUpdatingCart}
      acquisitionType={btnLocationEnum.boxSubscription}
      addToPublicCart={addToPublicCart}
    />
    {!isSubscriptionAvailable && !isParisHiltonKit && (
      <p className={styles.billingText}>
        Subsequent seasons billed at ${planPrice} for Seasonal membership plan.
      </p>
    )}
  </div>
);

SubscribableDetails.propTypes = {
  id: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  salePrice: PropTypes.string.isRequired,
  percentOff: PropTypes.number.isRequired,
  sku: PropTypes.string.isRequired,
  soldOut: PropTypes.bool.isRequired,
  planPrice: PropTypes.number.isRequired,
  shippingRestrictions: PropTypes.arrayOf(PropTypes.string).isRequired,
  ctaElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  isParisHiltonKit: PropTypes.bool,
  isSubscriptionAvailable: PropTypes.bool.isRequired,
  isUpdatingCart: PropTypes.bool.isRequired,
  addToPublicCart: PropTypes.func.isRequired,
};

SubscribableDetails.defaultProps = {
  isParisHiltonKit: false,
};

export default SubscribableDetails;
